module.exports = __webpack_public_path__ + "static/media/onewatch-logo-black_1012.png";